import React from 'react';
import { Stack, Typography } from '@mui/material';

function AdminEmptyState({ title, description }) {
  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: 200,
        px: 3,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6">{title}</Typography>
      {description ? (
        <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
          {description}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default AdminEmptyState;
